import React from 'react';
import { CheckCircleIcon, PlusIcon } from 'lucide-react';
interface EvaluationViewProps {
  userPlan: string;
}
export function EvaluationView({
  userPlan
}: EvaluationViewProps) {
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-308">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-309">
        <div data-id="element-310">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-311">Evaluation</h2>
          <p className="text-sm text-gray-600 mt-1" data-id="element-312">
            Assess and improve the quality of your AI outputs
          </p>
        </div>
        <button disabled={userPlan === 'Free'} className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-313">
          <PlusIcon className="w-4 h-4" data-id="element-314" />
          New Evaluation
        </button>
      </div>
      {/* Content placeholder */}
      <div className="bg-white rounded-lg border border-gray-200 p-8 text-center" data-id="element-315">
        <CheckCircleIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" data-id="element-316" />
        <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-317">
          AI Evaluation
        </h3>
        <p className="text-sm text-gray-600 max-w-md mx-auto" data-id="element-318">
          {userPlan === 'Free' ? 'This is a read-only demo. Upgrade to access AI evaluation tools.' : 'Create test cases, evaluate AI responses, and improve quality over time.'}
        </p>
      </div>
    </div>;
}